export default __webpack_public_path__ + "6316096bc8fecc4564de511738e29b8f.png";